import {TabList} from "@atlaskit/tabs";
import type {ComponentProps} from "react";

export function AnankeTabList(props: ComponentProps<typeof TabList>) {
    return <TabList {...props} />;
}
